import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './customer.routing';
import { AppComponent } from '../app.component';
import { CustomerInfoComponent } from './customer-info/customer.info.component';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { ImportComponent } from './import/import.component';
import { SummaryComponent, CustomerContactDialog, CustomerNoteDialog, CustomerDocumentDialog } from './summary/summary.component';

import { AuthGuard } from '../auth.guard';
import { CustomerService } from './services/customer.service';
import { RouterModule } from '@angular/router';
import { MobileListComponent } from './list/mobile/list-mobile.component';
import { DesktopListComponent } from './list/desktop/list-desktop.component';
import { SummaryMobileComponent } from './summary/summary-mobile/summary.mobile.component';
import { SummaryDesktopComponent } from './summary/summary-desktop/summary-desktop.component';
import { CustomerInfoMobileComponent } from './customer-info/customer-info-mobile/customer-info-mobile.component';
import { CustomerInfoDesktopComponent } from './customer-info/customer-info-desktop/customer-info-desktop.component';
import { ImportDialog } from './import/import-dialog/import.dialog';
import { ImportEditDialog } from './import/import-edit/import-edit.dialog';
import { TextNotificationhValidatorDirective } from './directives/validateTextNotificationData.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule
    ],
    declarations: [
        CustomerInfoComponent,
        ListComponent, MobileListComponent, DesktopListComponent,
        AddComponent,
        ImportComponent, ImportDialog, ImportEditDialog,
        SummaryComponent, SummaryMobileComponent, SummaryDesktopComponent,
        CustomerContactDialog, CustomerNoteDialog, CustomerDocumentDialog,
        CustomerInfoMobileComponent, CustomerInfoDesktopComponent,
        TextNotificationhValidatorDirective
    ],
    exports: [CustomerInfoComponent],
    providers: [AppComponent, AuthGuard, CustomerService]
})
export class CustomerModule { }
